const API_URL = "http://localhost:4000";

export default API_URL;